import PolicyCyclePeriod from "./policyCyclePeriod";
import PolicyEntitlement from "./policyEntitlement";
import PolicyGeneralInfo from "./policyGeneralInfo";
import PolicyAccrualOption from "./policyAccrualOption";
import PolicyApproval from "./policyApproval";
import PolicyAdvancedSetting from "./policyAdvancedSetting";

const createLeaveTabs = [
  {
    label: "General",
    number: 1,
    title: "General Information",
    subtitle: null,
    forms: (props) => <PolicyGeneralInfo {...props} />,
  },
  {
    label: "Cycle period",
    number: 2,
    title: "Leave Cycle Period",
    subtitle: "Set the cycle period for this leave.",
    forms: (props) => <PolicyCyclePeriod {...props} />,
  },
  {
    label: "Entitlement",
    number: 3,
    title: "Entitlement",
    subtitle: "Set the entitlement policy for this leave.",
    forms: (props) => <PolicyEntitlement {...props} />,
  },
  {
    label: "Accrual",
    number: 4,
    title: "Accrual option",
    subtitle: "Set the accrual option for this leave.",
    forms: (props) => <PolicyAccrualOption {...props} />,
  },
  {
    label: "Approval",
    number: 5,
    title: "Approval",
    subtitle: "Select or Create approval chain for this leave",
    forms: (props) => <PolicyApproval {...props} />,
  },
  {
    label: "Advanced settings",
    number: 6,
    title: "Advanced settings",
    forms: (props) => <PolicyAdvancedSetting {...props} />,
  },
];

export default createLeaveTabs;
